<template>
  <div>
    <div class="header">INSURANCE REPORT</div>
    <div class="ins-body">
      <a class="button cta small success" @click="getList">Refresh List</a>
      <a class="button cta small" @click="showCreate">Create Insurance</a>
      <!-- <pre>{{ insurance }}</pre> -->

      <table class="table-box" cellspacing="0">
        <thead>
          <th>Created Date</th>
          <th>ID</th>
          <th>Start Date</th>
          <th>End Date</th>
          <th>Miles per day</th>
          <th>RSVP Whitelist</th>
          <th>File</th>
          <th>Status</th>
          <th style="width:120px"></th>
        </thead>
        <tbody>
          <tr v-if="insurance.list && !insurance.list.length">
            <td colspan="9" class="empty">No record found.</td>
          </tr>
          <tr v-for="dat in insurance.list">
            <td>{{ formatdate(dat.createdUTC, true) }}</td>
            <td>{{ dat.id }}</td>
            <td>{{ formatdate(dat.startUTC) }}</td>
            <td>{{ formatdate(dat.endUTC) }}</td>
            <td>{{ dat.milesPerDay }}</td>
            <td>{{ dat.whitelist.join(', ') }}</td>
            <td>
              <a :href="dat.fileUrl" target="_blank" v-if="dat.fileUrl">
                <i class="fas fa-link fa-fw" ></i>
              </a>
              <span v-else>--</span>
            </td>
            <td><div :class="['status', dat.status]">{{ dat.status }}</div></td>
            <td>
              <a class="button cta small error" @click="confirmUpload(dat.id)" v-if="dat.status == 'ready'">UPLOAD</a>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <create-modal @refreshList="getList" />
    <confirm-upload :id="target" @refreshList="getList" />
  </div>
</template>

<script>
/* // global CONFIG */
import moment from 'moment'
import CreateModal from './CreateModal'
import ConfirmUpload from './ConfirmUpload'

export default {
  name: 'insurance',
  components: {
    CreateModal,
    ConfirmUpload
  },
  data () {
    return {
      target: 0
    }
  },
  computed: {
    insurance () { return this.$store.state.insurance }
  },
  methods: {
    showCreate () {
      this.$store.commit('insurance/setListData', {showCreate: true})
    },
    getList () {
      let self = this
      self.$store.commit('global/setLoaderData', {show: true})
      self.$sdk.post('/insurance/list', {
        token: self.$store.state.session.sessionToken
      }, r => {
        self.$store.commit('global/setLoaderData', {show: false})
        if (r.error) {
          self.$store.commit('insurance/setListData', {list: []})
          self.$store.commit('global/setAlertData', {
            show: true,
            message: r.error.message
          })
          return
        }
        self.$store.commit('insurance/setListData', {list: r.list})
      }, '2.0')
    },
    formatdate (x, withTime = false) {
      if (!x) return '--'
      let format = !withTime ? 'MM/DD/YYYY' : 'MM/DD/YY hh:mmA'
      return moment(x, 'X').format(format)
    },
    confirmUpload (id) {
      this.target = id
      this.$store.commit('insurance/setListData', {showConfirm: true})
    }
  },
  mounted () {
    let access = this.$store.state.session.user.access
    if (!access.hasOwnProperty('PageAdminInsurance')) {
      this.$router.push({name: 'MissingPage'})
      return
    }
    this.getList()
  }
}
</script>

<style lang="scss" scoped>
.header {
  font-weight: 700;
  font-size: 22px;
  color: #3F2975;
  background-color: #fff;
  display: block;
  line-height: 22px;
  padding: 14px 0 14px 64px;
  border-bottom: 1px solid rgba(0,0,0,0.15);
}

.ins-body{
  padding: 20px;
}

.table-box{
  margin-top: 30px;
  width: 100%;
  border: 1px solid #333;
  background: #fafafa;
  border-radius: 4px;
  overflow: hidden;

  th{
    border-bottom: 1px solid #ddd;
    padding: 5px;
    background: #333;
    color: #fff;
  }
  tr{
    text-align: center;
  }
  td{
    font-size: 14px;
    padding: 7px;
  }
  tr:nth-child(odd) td{
    background: #f3f3f3;
  }
  .empty{
    padding: 30px;
    font-weight: 600;
    font-size: 28px;
    color: #777;
  }
}
.fa-link{
  color: #3083f0;
}
.status{
  font-size: 12px;
  letter-spacing: .3px;
  padding: 3px 10px;
  background: #333;
  color: #fff;
  border-radius: 3px;
  text-transform: uppercase;
  display: inline-block;
  font-family: monospace;

  &.ready{
    color: #3a92e4;
    border: 1px solid #3a92e4;
    background: #cfe8ff;
  }
  &.creating{
    color: #cbaf17;
    border: 1px solid #cbaf17;
    background: #fdf9e3;
  }
  &.uploaded{
    color: #16bb48;
    background: #c1ffd4;
    border: 1px solid rgba(0, 0, 0, .3);
  }
  &.error{
    color: #df2323;
    background: #ffb1b1;
    border: 1px solid #df2323;
  }
}

@media only screen and (max-width: 430px) {
}
</style>



// WEBPACK FOOTER //
// src/components/Insurance/index.vue